import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Toaster } from "sonner";

// Stable ref so <Toaster/> doesn't get a new prop object on every render.
const TOAST_OPTIONS = {
    style: {
        background: "#0A0E17",
        border: "1px solid rgba(140,190,210,0.2)",
        color: "#F5F8F8",
        borderRadius: 0
    }
};

export const Layout = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div className="min-h-screen bg-brand-bg text-brand-mist">
            <Header />
            <main className="pt-20">
                <Outlet />
            </main>
            <Footer />
            <WhatsAppButton />
            <Toaster
                theme="dark"
                position="top-right"
                toastOptions={TOAST_OPTIONS}
            />
        </div>
    );
};
